import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Text} from '../../atoms/Text/Text';

export interface HintProps {
  label: string;
  labelColor?: string;
  backgroundColor?: string;
  className?: string;
  style?: React.CSSProperties;
  testId?: string;
  fontSize?: keyof typeof FONT_SIZES;
  weight?: keyof typeof FONT_WEIGHTS;
}

export const Hint: FC<React.PropsWithChildren<HintProps>> = ({
  label,
  labelColor = COLORS.Black,
  backgroundColor = COLORS.LowStock,
  className,
  style,
  testId,
  children,
  fontSize = 'px10',
  weight = 'bold',
}) => {
  return (
    <Wrapper
      $labelColor={labelColor}
      $backgroundColor={backgroundColor}
      className={className}
      style={style}
      data-testid={testId || 'hint'}
    >
      <StyledText size={fontSize} weight={weight}>
        {label}
      </StyledText>
      {children}
    </Wrapper>
  );
};

const StyledText = styled(Text)``;

const Wrapper = styled.div<{
  $labelColor: HintProps['labelColor'];
  $backgroundColor: HintProps['backgroundColor'];
}>`
  width: 100%;
  padding-bottom: 3px;
  border-radius: 2px;
  background: ${({$backgroundColor}) => $backgroundColor};
  text-align: center;
  box-sizing: border-box;

  ${StyledText} {
    color: ${({$labelColor}) => $labelColor};
  }
`;
